import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { firebaseAuth } from '../../lib/firebase'
import { completeSso, createPortalLaunchUrl } from './ssoClient'

export default function SsoRoute({ mode }) {
  const location = useLocation()
  const navigate = useNavigate()
  const started = useRef(false)
  const [error, setError] = useState(
    firebaseAuth ? '' : 'Firebase is not configured for this deployment.',
  )

  useEffect(() => {
    if (started.current) return
    started.current = true
    if (!firebaseAuth) return

    if (mode === 'start') {
      const returnTo = new URLSearchParams(location.search).get('returnTo')
      createPortalLaunchUrl(returnTo)
        .then((url) => window.location.replace(url))
        .catch((reason) => setError(reason.message))
      return
    }

    completeSso(firebaseAuth, location.search)
      .then((returnTo) => navigate(returnTo, { replace: true }))
      .catch((reason) => setError(reason.message))
  }, [location.search, mode, navigate])

  return (
    <main className="grid min-h-screen place-items-center bg-[#f5f1e8] px-5 text-[#102a2c]">
      <section className="w-full max-w-lg border-t-4 border-amber-500 bg-white p-8 shadow-xl">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-700">
          PreNexus secure access
        </p>
        <h1 className="mt-4 text-3xl font-semibold">
          {error ? 'Unable to open PreNexus' : 'Connecting your workspace...'}
        </h1>
        <p className="mt-4 leading-7 text-slate-600">
          {error || 'Your one-time LPHTM portal session is being verified.'}
        </p>
        {error ? (
          <a
            className="mt-7 inline-flex bg-[#102a2c] px-5 py-3 text-sm font-bold uppercase tracking-wider text-white"
            href="/sso/start"
          >
            Start again
          </a>
        ) : (
          <span className="mt-8 block h-1 w-full overflow-hidden bg-slate-200">
            <span className="block h-full w-1/2 animate-pulse bg-amber-500" />
          </span>
        )}
      </section>
    </main>
  )
}
